<template>
  
    <div>
      <!--ROW5-->
      <!-- Asociaciones -->
    <!--<v-layout row wrap style="background-color:#f5f5f5; height:min-contain" >
      <v-flex  class="" xs12 sm12 md12 lg12 offset-md1 offset-lg1> 
        
            
        <v-layout class="hidden-sm-and-down">     
          <v-flex style="padding:4vw" xs6 sm6 md6 lg6>
            <v-carousel class="remove-shadow" hide-delimiters hide-controls  height="min-contain">
              <v-carousel-item
              v-for="(item,i) in items"
              :key="i"
              :src="item.src"
              reverse-transition="fade"
              transition="fade">
              </v-carousel-item>
            </v-carousel>
          </v-flex>
          <v-flex class="footer" xs5 sm5 md4 lg4>
            <p style="text-align:center">{{row4_text1}}</p>
            <v-layout class="mt-5">
              <v-img  class="hidden-sm-and-down" src="logos_2.png"/>
              <v-img  class="hidden-md-and-up"  src="logos_2.png"/>
            </v-layout>
          </v-flex>
        </v-layout>

       
        <v-layout justify-center class="hidden-md-and-up">
          <v-flex style="padding:4vw" xs10 sm10 md6 lg6>
            <v-carousel class="remove-shadow" hide-delimiters hide-controls height="min-contain">
              <v-carousel-item
              v-for="(item,i) in items"
              :key="i"
              :src="item.src"
              reverse-transition="fade"
              transition="fade">
              </v-carousel-item>
            </v-carousel>
          </v-flex>
        </v-layout>

        <v-layout justify-center>
          <v-flex class="footer" xs8 sm8 md5 lg5>
            <p class="hidden-md-and-up" style="text-align:center">{{row4_text1}}</p>
          </v-flex>
        </v-layout>
        <v-layout  justify-center class="mt-5 mb-4 hidden-md-and-up">
          <v-flex class="footer" xs8 sm8 md5 lg5>
            <v-img  class="hidden-sm-and-down" src="logos_2.png"/>
            <v-img  class="hidden-md-and-up" style="margin-top:-10%" src="logos_2.png"/>
          </v-flex>
        </v-layout>  
       </v-flex>    
      </v-layout>-->


    <!--ROW6-->
    <v-layout class="hidden-sm-and-down" justify-center row wrap style="background-color:#0F3072">
      <v-flex style="paddin:3vw" xs12 sm12 md10 lg10 class="md_screen">
        <v-layout justify-center>
          <v-flex style="padding:4vw" xs4 sm4 md4 lg4>
            <br><br><v-img src="Lalabum-logohorizontal20080.png" width="180px"></v-img>
          </v-flex>
          <v-flex style="padding:4vw" xs4 sm4 md4 lg4>
            <!--<a class="linkfooter" @click.stop="dialogcontact = true">-->
              <a class="linkfooter" href="https://api.whatsapp.com/send?phone=+526691960183" target="_blank">
              <p class="text-footer" >{{row2_text1}}</p> 
            <!--<p style="margin-top:-18%" class="text-footer" >{{row2_text1}}</p> -->
            </a>
            <a class="linkfooter" href="https://www.lalabumapp.com/privacidad/avisodeprivacidad.html" target="_blank">
              <p style="margin-top:-18%" class="text-footer" >{{row2_text2}}</p>  
            </a>
            <!--<a class="linkfooter" href="https://www.lalabumapp.com/privacidad/terminosycondiciones.html" target="_blank">
              <p style="margin-top:-18%" class="text-footer" >{{row2_text3}}</p>  
            </a>-->
          </v-flex>
          <v-flex style="padding:4vw" xs4 sm4 md4 lg4>
            <p class="text-footer" style="font-weight:700" >{{row2_text4}}</p>
            <p style="margin-top:-18%" class="text-footer" ><v-icon color="white">email</v-icon> {{row2_text5}}</p>
            <p style="margin-top:-18%" class="text-footer" ><v-icon color="white">local_phone</v-icon> {{row2_text6}}</p>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- ROW6 MOBILE -->
    <v-layout row wrap style="background-color:#0F3072; margin-bottom:-2px" class="hidden-md-and-up" justify-center>
      <v-flex class="pa-4" xs12 sm12 md10 lg10 >
        <v-img src="Lalabum-logohorizontal20080.png" width="180px" style="margin-left:25%"></v-img>
          <v-layout justify-center style="margin-top:6%">
            <v-flex class="tools" style="padding:3vw" xs8 sm8 md3 lg3>
              <a class="linkfooter" href="https://api.whatsapp.com/send?phone=+526691960183" target="_blank">
                <!--<p slot="badge" @click.stop="dialogcontact = true" class="text-center text-guia" style="font-size:4.5vw; text-align:center; color:white">{{row2_text1}}</p>-->
                <p class="text-center text-guia" style="font-size:4.5vw; text-align:center; color:white">{{row2_text1}}</p>          
              </a>        
            </v-flex>
           </v-layout>
           <v-layout justify-center >
            <v-flex class="tools" style="padding:3.5vw" xs8 sm8 md3 lg3>
              <a class="linkfooter" href="https://www.lalabumapp.com/privacidad/avisodeprivacidad.html">
                <p class="text-center text-guia" style="font-size:4.5vw; text-align:center; color:white; margin-top:-15%">{{row2_text2}}</p>
              </a>
            </v-flex>
          </v-layout>
          <!--<v-layout justify-center>
            <v-flex class="tools" style="padding:3.5vw" xs8 sm8 md3 lg3>
              <a class="linkfooter" href="https://www.lalabumapp.com/privacidad/terminosycondiciones.html">
                <p class="text-center text-guia" style="font-size:4.5vw; text-align:center;color:white;margin-top:-15%">{{row2_text3}}</p>                      
              </a>
            </v-flex>
          </v-layout>-->
          <v-layout justify-center>
            <v-flex style="padding:4vw" xs9 sm9 md4 lg4>
              <p class="text-footer" style="font-weight:700; text-align:center;font-size:4.5vw; margin-top:-15% " >{{row2_text4}}</p>
              <p style="margin-top:-8%; font-size:4vw; text-align:center;" class="text-footer" ><v-icon color="white">email</v-icon> {{row2_text5}}</p>
              <p style="margin-top:-8%; font-size:4vw; text-align:center" class="text-footer" ><v-icon color="white">local_phone</v-icon> {{row2_text6}}</p>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

    <!-- Dialog contact -->

    <v-dialog v-model="dialogcontact" max-width="550">
              <v-card style="border-radius:7px; bak">
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn  fab dark color="#2f478d"  @click="dialogcontact = false">
                          <!--<p  style="font-family:Fredoka one; font-size:2.8vw">X</p>-->
                    <v-icon dark x-large style="height:auto;width:auto">close</v-icon>
                  </v-btn>
                </v-card-actions>

                <v-card-title>
                  <div align="center">
                    <span class="headline"></span>
                  </div>
                </v-card-title>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout style="margin-top-60%" xs12 sm12 md12 lg12 wrap>                        
                      <v-flex xs12 sm12 md12 lg12>
                            <!--v-text-field v-model="name" label="Nombre" required></--><!--v-text-field>-->
                        <p align="center" style="color:#338ec9;font-family:Fredoka one;font-size:3.5vw" class="hidden-sm-and-down">Contáctanos</p>
                        <p align="center" style="color:#338ec9;font-family:Fredoka one;font-size:8vw" class="hidden-md-and-up">Contáctanos</p>
                      </v-flex>
                          <v-flex xs12 sm12 md12 lg12>
                            <!--<v-text-field v-model="email" label="Correo electronico" required></v-text-field>-->
                             <p align="center" style="color:#7a7a7a;font-family:Poppins;font-size:1.8vw" class="hidden-sm-and-down">info@lalabumapp.com</p>
                             <p align="center" style="color:#7a7a7a;font-family:Poppins;font-size:6vw" class="hidden-md-and-up">info@lalabumapp.com</p>
                          </v-flex>  
                          <v-flex xs12 sm12 md12 lg12>
                            <!--<v-text-field v-model="select" label="Soy Padre, Maestro o Lider Educativo" required></v-text-field>-->
                            <p align="center" style="color:#7a7a7a;font-family:Poppins;font-size:1.8vw" class="hidden-sm-and-down">669 266 6060</p>
                            <p align="center" style="color:#7a7a7a;font-family:Poppins;font-size:6vw" class="hidden-md-and-up">669 266 6060</p>
                          </v-flex>  
                          <!--<v-flex xs12 sm12 md12 lg12>
                            <v-text-field v-model="school" label="Escuela"></v-text-field>
                          </v-flex>                                               
                          <v-flex xs12 sm12 md12 lg12>
                            <v-textarea v-model="Message" label="Message" color="teal" >
                                <template v-slot:label>
                                    <div>
                                        Mensaje <small>(optional)</small>
                                    </div>
                                  </template>
                            </v-textarea>
                          </v-flex>-->

                          <v-layout justify-center>
                            <v-btn
                              
                              color="'primary'"
                              @click="dialogcontact = false"
                            >
                              Enviar Mensaje
                            </v-btn>
                            <v-icon dark x-large style="height:auto;width:auto">close</v-icon>

                            </v-layout>
                        </v-layout>
                      </v-container>
                      <small></small>
                    </v-card-text>
                    <!--<v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click="dialogcontact = false">Enviar</v-btn>
                     
                    </v-card-actions>-->

                    </v-card>
              </v-dialog>


    <!--ROW7-->
    <v-layout justify-center row wrap style="background-color:#0F3072">
      <v-flex mb-2 xs12 sm12 md10 lg10  class="md_screen">
        <v-layout justify-center>
          <v-flex style="padding:1vw" xs2 sm2 md1 lg1>
            <a href="https://www.instagram.com/lalabumeditorial/" target="_blank">
              <v-img v-if=true src="instagram.png"></v-img>
            </a>
          </v-flex>
          <v-flex style="padding:1vw" xs2 sm2 md1 lg1>
            <a href="https://www.facebook.com/Lalabumeditorial" target="_blank">
              <v-img v-if=true src="facebook.png"></v-img>
            </a>
          </v-flex>
          <v-flex style="padding:1vw" xs2 sm2 md1 lg1>
            <a href="https://open.spotify.com/album/4Hie83iGijeoq9u9CN9WHF?utm_source=hs_email&utm_medium=email&utm_content=69489615&_hsenc=p2ANqtz-_rkeI9tnhdTfBZsySp4XZT4fqt-iPawEbSGBRJAD0cpR3gD-nBNTg3rglUWi7tc6JpjgHQbqjK7X583rPhesjgoZQm0w&_hsmi=69489615" target="_blank">
              <v-img v-if=true src="spotify.png"></v-img>
            </a>
          </v-flex>
          <v-flex style="padding:1vw" xs2 sm2 md1 lg1>
            <a href="https://www.youtube.com/channel/UCuNE-4L5V5PEnHfqqft24mw?utm_source=hs_email&utm_medium=email&utm_content=69489615&_hsenc=p2ANqtz-_rkeI9tnhdTfBZsySp4XZT4fqt-iPawEbSGBRJAD0cpR3gD-nBNTg3rglUWi7tc6JpjgHQbqjK7X583rPhesjgoZQm0w&_hsmi=69489615" target="_blank">
              <v-img v-if=true src="youtube.png"></v-img>
            </a>
          </v-flex>
        </v-layout>     
      </v-flex>
    </v-layout>
  </div>

</template>


<script>

export default {
  data() {
    let language=localStorage.getItem('language');
      if (language=='es-XL' || language=='es') 
      {
        return{
          dialogcontact:false,
          Message:'',
          name:'',
          email:'',
          select:'',
          school:'',
         /* Message:'',*/
          row1_text1:'Desarrollado por educadores para educadores basado en los cuatro pilares de la educación',
          row2_text1:'Contacto',
          row2_text2:'Aviso de privacidad',
          row2_text3:'Términos y Condiciones',
          row2_text4:'Servicio al cliente',
          row2_text5:'info@lalabumapp.com',
          row2_text6:'669 196 0183',
          row4_text1:'Asociaciones que confían en Lalabum',
          items: [
          {
            src: 'opinion-22.png'
          },
          {
            src: 'opinion-23.png'
          },
          {
            src: 'opinion-24.png'
          },
          {
            src: 'opinion-25.png'
          }
        ]

        }
      } else {
        return{
          dialogcontact:false,
          Message:'',
          name:'',
          email:'',
          select:'',
          school:'',
          row1_text1:'Developed by educators for educators based on the four pillars of education',
          row2_text1:'Contact',
          row2_text2:'Notice of privacy',
          row2_text3:'Terms and conditions',
          row2_text4:'Support',
          row2_text5:'info@lalabumapp.com',
          row2_text6:'669 196 0183',
          row4_text1:'Associations that trust Lalabum',
          items: [
          {
            src: 'opinion-38.png'
          },
          {
            src: 'opinion-39.png'
          },
          {
            src: 'opinion-40.png'
          },
          {
            src: 'opinion-41.png'
          }
        ]
        }
      }
      
    }

    /*data: () => ({
      dialog: false
    }),
    methods:
    {
      
    }*/
  }
</script>


<style>
/* PC */
@media screen and (min-width: 960px) {
  .md_screen {
   margin-top: -60px;
  }
  .md_screen p{
   font-size: 1.3vw;
  }

  .title_foot{
    font-size: 1.3vw;
  }

  .text-footer{
    font-size: 1vw!important;
  }

  .footer p{
      font-size: 1.2vw;
  }

  .footer{
      padding-top: 6vw;
  }
}
/* ---- */

/* Movil */
@media screen and (max-width: 480px) {
  .md_screen p{
   font-size: 2.5vw;
  }

  .title_foot{
    font-size: 2.5vw;
    
  }

  .footer p{
      font-size: 3.5vw;
  }

  .footer{
      padding-top: 6vw;
  }

}
/* ---- */

/* Asociaciones*/

.title_foot{
  color: gray;
  font-weight: 200; 
  padding-top: 2vw;
  text-align: center;
  font-family: 'Poppins', sans-serif;
}

.footer p{
  color: gray;
  font-weight: 200; 
  
  text-align: center;
  font-family: 'Poppins', sans-serif;
}


.linkfooter{
  text-decoration: none;
}

.text-footer{
  color:white;
  font-family:  'Poppins', sans-serif;
  font-weight: 500;
  padding-top: 3vw;
  text-align: left;
}

.remove-shadow{
  box-shadow:none !important;
  web-kit-box-shadow:none !important;
}


</style>

<style lang="stylus">
  #example-custom-transition
    .fade
      &-enter-active, &-leave-active, &-leave-to
        transition: .3s ease-out
        position: absolute
        top: 0
        left: 0

      &-enter, &-leave, &-leave-to
        opacity: 0
</style>